import { TApiPagRes } from "@/types/api";

// Whitelisted free-text Partner columns exposed by GET /partners/field-options.
export const PARTNER_FIELD_OPTIONS_FIELDS = ["location", "contactPerson", "partnerName", "managementNumber"] as const;
export type TPartnerFieldOptionsField = (typeof PARTNER_FIELD_OPTIONS_FIELDS)[number];

export type TGetPartnerFieldOptionsReqDto = {
  field: TPartnerFieldOptionsField;
  page?: number;
  perPage?: number;
  search?: string;
};

export type TGetPartnerFieldOptionsResDto = TApiPagRes<string>;

/** GET /partners/field-options/batch — first page of all 4 fields in one response. */
export type TGetPartnerFieldOptionsBatchResDto = Record<TPartnerFieldOptionsField, TGetPartnerFieldOptionsResDto>;
